import React from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';


import NavBarLateral from '../NavBarLateral/index';

class AdminEquipoEliminar extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            isLogged: this.props.auth,
        };
    }

    render(){
        if(this.state.isLogged === true){
            return (
                <div>
                    <NavBarLateral />
                    <div className={`pad`}>
                        <NavTitulo />
                        <div className={`row`}>
                            <TarjetaEliminar
                                id={this.props.location.state.id}
                                rutaRegreso={this.props.location.state.rutaRegreso}/>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return <Redirect to="/administrador/login"/>
        }
    }
}

class TarjetaEliminar extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            adminExitoso: false,
            descripcionExitoso: false,
            eliminar: false,
            id: '',
        };
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentWillMount(){
        this.setState({id: this.props.id})
    }

    handleDelete(){

        fetch('/api/uip/equipo/' + this.props.id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    adminExitoso: true,
                    descripcionExitoso: 'Se elimino el integrante exitosamente',
                })
            })
            .catch(response => {
                this.setState({
                    eliminar: true,
                    descripcionExitoso: 'no existe el integrante',
                })
            })
    }

    render() {

        if(this.state.eliminar === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/error/general',
                        state: { 
                            descripcionError: this.state.descripcionError,
                            rutaRegreso: '/administrador/equipo' 
                        }
                    }}
                />
           );
        }

        if(this.state.adminExitoso === true){
            return(
                <Redirect 
                    to={{
                        pathname: '/administrador/proceso/exitoso',
                        state: { 
                            descripcionError: this.state.descripcionExitoso,
                            rutaRegreso: '/administrador/equipo' 
                        }
                    }}
                />
           );
        }

        return (
            <div className="row">
                <div className="col s12 m1 l3"></div>
                <div className="col s12 m10 l6">
                    <div className="card">
                        <div className="card-content red lighten-1">
                            <span className="card-title white-text"><i className="material-icons">cancel</i> Esta seguro que desea eliminará al Integrante ?</span>
                        </div>
                        <div className="card-content">
                            <p className="">{this.props.texto}</p>
                        </div>
                        <div className="card-action">
                            <Link to={this.props.rutaRegreso}>
                                <a className="waves-effect waves-light btn blue">
                                    <i className="material-icons right">keyboard_return</i>
                                    Regresar
                                </a>
                            </Link>
                            <a className="waves-effect waves-light btn red lighten-1" 
                               onClick={this.handleDelete}>
                                <i className="material-icons right">send</i>
                                Eliminar
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col s12 m1 l3"></div>
            </div>
           
        );
    }
}

class NavTitulo extends React.Component{
    render(){
        return(
            <div className="navbar-fixed">
                <nav className="light-blue">
                    <div className="nav-wrapper">
                        <a className="brand-logo margin-titulo-especiales">
                                Eliminar
                                <span 
                                    className="new badge red lighten-1 margin-badge-nav"
                                    data-badge-caption="??">
                                    {this.props.cantidad}
                                </span>
                        </a>
                    </div>
                </nav>
            </div>
         
        );
    }
}

export default AdminEquipoEliminar; 